import React, { useMemo } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ROUTES } from './routes';
import { PaymentDetails, Pricing, Processing, Signup } from './pages';
import { useFirebase } from './context';

const routes = [
  {
    path: ROUTES.PRICING,
    isProtected: true,
    Component: Pricing,
  },
  {
    path: ROUTES.PAYMENT_DETAILS,
    isProtected: true,
    Component: PaymentDetails,
  },
  {
    path: ROUTES.PROCESSING,
    isProtected: true,
    Component: Processing,
  },
  {
    path: ROUTES.INVITE,
    Component: Signup,
  },
  {
    path: ROUTES.HOME,
    Component: Signup,
  },
];

export const SignupRouter: React.FC = (): JSX.Element => {
  const { isLoggedIn, isInitialized } = useFirebase();

  const mappedRoutes = useMemo(
    () =>
      routes.map(({ path, Component, isProtected }) => {
        if (isProtected && isInitialized && !isLoggedIn) {
          return (
            <Route key={path} exact path={path}>
              <Redirect key={path} to={ROUTES.HOME} />
            </Route>
          );
        }

        return (
          <Route key={path} exact path={path}>
            <Component />
          </Route>
        );
      }),
    [isInitialized, isLoggedIn]
  );

  return <Switch>{mappedRoutes}</Switch>;
};
